import {Box, Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useCallback, useMemo, useState} from "react";
import {HiCurrencyDollar} from "react-icons/hi2";
import {SlRefresh} from "react-icons/sl";
import GlobalDateField from "../../global-fields/GlobalDateField";
import GlobalTextField from "../../global-fields/GlobalTextField";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import GlobalModal from "../../global-fields/GlobalModal";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {SiAdobe as SiAdobereader} from "react-icons/si";
import {ERR_MESSAGE, MANDATORY_QUES} from "../../../constants/constants";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../../constants/helper";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {
  AGENT_CLIENTS,
  AGENT_ISSUED_POLICIES,
  AGENT_POLICY_RENEW,
  ISSUED_POLICIES,
  POLICY_RENEW,
  REQUEST_CLAIM,
} from "../../../constants/apiConstant";
import GlobalTextAriaField from "../../global-fields/GlobalTextArea";
import dayjs from "dayjs";
import {useEffect} from "react";
import ClaimFormModal from "../../claim-form-modal/ClaimFormModal";
import NoDataComponent from "../../no-data";

const LossTypeMenuItems = [
  {name: "Mysterious Disappearance", value: "Mysterious Disappearance"},
  {name: "⁠Shipping", value: "⁠Shipping"},
  {name: "⁠Travel", value: "⁠Travel"},
  {name: "⁠Burglary", value: "⁠Burglary"},
  {name: "⁠Robbery", value: "⁠Robbery"},
  {name: "Other", value: "Other"},
];

const columns2 = [
  {id: "id", label: "#", minWidth: 25},
  {id: "proposal_id", label: "Proposal Number", minWidth: 160},
  {id: "hardQuote", label: "Hard Quote Amt", minWidth: 120},
  {id: "proposalDateTime", label: "Issued Date", minWidth: 110},
  {id: "status", label: "Status", minWidth: 70},
  {id: "Policy", label: "Policy", minWidth: 70},
  {id: "claim", label: "Claim", minWidth: 70},
  {id: "Endorsement", label: "Endorsement", minWidth: 80},
  {id: "Exhibition", label: "Exhibition", minWidth: 70},
  {id: "expiryDate", label: "Expiry Date", minWidth: 100},
  {id: "renewal", label: "Renewal", minWidth: 70},
];

const rows = Array.from({length: 10}, (_, index) => ({
  id: index + 1,
  proposal_id: "PROP10292024-1540",
  hardQuote: "$14,000",
  proposalDateTime: "12/10/2025",
  status: index == 1 || index == 2 ? 1 : 0,
  companyName: "Associated International Brokers, Inc",
  expiryDate: "12/10/2025",
}));

const options = ["Endorsement", "Exhibition Coverage"];

const ITEM_HEIGHT = 48;

const IssuedPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {showLoader} = useSelector(selectUiState);
  const {issuedPoliciesData, issuedPoliciesCount} =
    useSelector(selectDataStoreState);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const issuedPolicyList = useMemo(
    () => (issuedPoliciesData?.length ? issuedPoliciesData : []),
    [issuedPoliciesData]
  );
  // const currentRowData = useMemo(() => currentRow, [currentRow]);
  // console.log("issuedPolicyList", issuedPolicyList);

  const [openClaimForm, setClaimForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickOpenClaimForm = (row) => {
    setCurrentRow(row);
    setClaimForm(true);
    dispatch(
      setDataStore({
        claimFormParentData: row,
      })
    );
    dispatch(
      setUiData({
        claimFormModal: true,
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchIssuedPolicies = useCallback(async () => {
    if (page == null || rowsPerPage == null || !user?.id) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      ...(user?.user_type === "agent"
        ? {agent_id: user.id}
        : {user_id: user.id}),
    };

    const apiDetails =
      user?.user_type === "agent" ? AGENT_ISSUED_POLICIES : ISSUED_POLICIES;

    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();

      if (res.status == 1) {
        dispatch(
          setDataStore({
            issuedPoliciesData: res?.policy_list || [],
            issuedPoliciesCount: res?.total_count || 0,
          })
        );
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: res?.message || "Failed to fetch issued policies.",
        });
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({
        type: "error",
        message: error.message || "Something went wrong",
      });
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [page, rowsPerPage, user]);

  useEffect(() => {
    fetchIssuedPolicies();
  }, [fetchIssuedPolicies]);

  const handleEndorsementBtn = (row) => {
    dispatch(setDataStore({endorsementParentProposal: row}));
    navigate("/endorsements");
  };
  const handleExhibitionBtn = (row) => {
    dispatch(setDataStore({exhibitionParentProposal: row}));
    navigate("/exhibition-coverage");
  };
  const handleRenew = async (row) => {
    if (!row || !user?.id) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      proposal_id: row?.proposal_id,
      ...(user?.user_type === "agent"
        ? {agent_id: user.id}
        : {user_id: user.id}),
    };

    const apiDetails =
      user?.user_type === "agent" ? AGENT_POLICY_RENEW : POLICY_RENEW;
    // console.log("Renew data:", data, apiDetails?.url);
    dispatch(setUiData({showLoader: false}));
    return;
    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();

      if (res.status == 1) {
        dispatch(
          setDataStore({
            issuedPoliciesData: res?.policy_list || [],
            issuedPoliciesCount: res?.total_count || 0,
          })
        );
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: res?.message || "Failed to fetch issued policies.",
        });
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({
        type: "error",
        message: error.message || "Something went wrong",
      });
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  };
  const clientSearch = async (searchTerm,company_name) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: 10,
      offset: 0,
      search: searchTerm,
      company:company_name
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list?.[0] ?? null;
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return null;
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return null;
    }
  };

  const handleRenewBtn = async (row) => {
    if (user?.user_type === "agent") {
      const client_ = await clientSearch(row.full_name,row.firm_name);
      if (client_) {
        dispatch(setAuthData({selectedClient: client_}));
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: "Client Details Not Found!",
        });
        return;
      }
    }
    // console.log("ROWWWW",row)
    // return;
    dispatch(
      setDataStore({
        proposalStep: 1,
        proposal_id: row.proposal_id,
        previous_proposal_id: row.proposal_id,
      })
    );

    navigate("/new-proposal");
  };

  const columns = [
    {
      id: "id",
      label: "#",
      minWidth: 25,
      // renderCell: (row) => row.value,
    },
    {
      id: "policy_number",
      label: "Policy Number",
      minWidth: 160,
      renderCell: (row) => (
        <div>
          <Link
            to={"/details/policy/" + row.proposal_id}
            style={{color: "#000"}}
          >
            {row.policy_number}
          </Link>
        </div>
      ),
    },
    {
      id: "full_name",
      label: "Client Name",
      minWidth: 160,
      renderCell: (row) => row.full_name,
      // renderCell: (row) => (
      //   <div>
      //     <Link to={"/details/client/" + row.user_id} style={{ color: "#000" }}>
      //       {row.full_name}
      //     </Link>
      //   </div>
      // )
    },
    {
      id: "status",
      label: "Status",
      minWidth: 70,
      renderCell: (row) =>
        row.status === "Active" ? (
          <Button
            style={{color: "#00ba34"}}
            disabled
            className={style.IssuedPolicyBtnSucces}
          >
            Active
          </Button>
        ) : (
          <Button disabled={row.status !== 1} style={{background: "#f1f1f1"}}>
            Expired
          </Button>
        ),
    },
    {
      id: "formated_hard_quote",
      label: "Hard Quote Amt",
      minWidth: 120,
      renderCell: (row) => row.formated_hard_quote,
    },
    {
      id: "issued_date",
      label: "Issued Date",
      minWidth: 110,
      renderCell: (row) => row.issued_date,
    },
    {
      id: "expiry_date",
      label: "Expiry Date",
      minWidth: 100,
      renderCell: (row) => row.expiry_date,
    },
    {
      id: "claim",
      label: "Claim",
      minWidth: 70,
      renderCell: (row) => (
        <Button
          variant="contained"
          size="small"
          style={{
            marginRight: 8,
            background: row.status !== "Active" ? "#f1f1f1" : "#004F71",
          }}
          onClick={() => handleClickOpenClaimForm(row)}
          disabled={row.status !== "Active"}
        >
          <HiCurrencyDollar /> Claim
        </Button>
      ),
    },
    {
      id: "Endorsement",
      label: "Endorsement",
      minWidth: 80,
      renderCell: (row) => (
        <Button
          variant="contained"
          size="small"
          style={{
            marginRight: 8,
            background: row.status !== "Active" ? "#f1f1f1" : "#004F71",
          }}
          onClick={() => handleEndorsementBtn(row)}
          disabled={row.status !== "Active"}
        >
          Endorsement
        </Button>
      ),
    },
    {
      id: "Exhibition",
      label: "Exhibition",
      minWidth: 70,
      renderCell: (row) => (
        <Button
          variant="contained"
          size="small"
          style={{
            marginRight: 8,
            background: row.status !== "Active" ? "#f1f1f1" : "#004F71",
          }}
          onClick={() => handleExhibitionBtn(row)}
          disabled={row.status !== "Active"}
        >
          Exhibition
        </Button>
      ),
    },
    {
      id: "Policy",
      label: "Policy",
      minWidth: 70,
      renderCell: (row) => (
        <Button
          variant="contained"
          size="small"
          style={{
            marginRight: 8,
            background: "#F5F5F5",
            color: "#2C2C2C",
            border: "1px solid rgba(0, 0, 0, 0.11)",
          }}
          onClick={() => handlePDF(row)}
        >
          <SiAdobereader
            style={{marginRight: "7px", fontSize: "18px"}}
            color="#FF2116"
          />
          PDF
        </Button>
      ),
    },
    {
      id: "renewal",
      label: "Renewal",
      minWidth: 70,
      renderCell: (row) => (
        <Button
          variant="contained"
          style={{
            background:
              (row.status !== "Active" && user?.user_type === "agent") ||
              (row.status !== "Active" && user?.user_type === "user")
                ? "#00BA34"
                : "#f1f1f1",
          }}
          disabled={
            (user?.user_type === "agent" && row.status === "Active") || // disabled if agent and active
            (user?.user_type === "user" && row.status === "Active") // disabled if client and active
          }
          onClick={() => handleRenewBtn(row)}
        >
          <SlRefresh /> Renew
        </Button>
      ),
    },
  ];
  const agentColumns = [
    ...columns.slice(0, 2), // for example, insert after index 1
    {
      id: "company",
      label: "Company Name",
      minWidth: 160,
      renderCell: (row) => row.company,
    },
    {
      id: "full_name",
      label: "Client Name",
      minWidth: 160,
      renderCell: (row) => row.full_name,
      // renderCell: (row) => (
      //   <div>
      //     <Link to={"/details/client/" + row.user_id} style={{ color: "#000" }}>
      //       {row.full_name}
      //     </Link>
      //   </div>
      // )
    },
    ...columns.slice(2),
  ];
  const handlePDF = (row) => {
    // console.log(" PDF:", row?.policy_file);
    if (!row?.policy_file) {
      console.error("Invalid PDF URL");
      return;
    }
    window.open(row?.policy_file, "_blank");
  };

  useEffect(() => {
    const paginationInputs = document.querySelectorAll(
      ".MuiSelect-nativeInput"
    );
    paginationInputs.forEach((input, index) => {
      // Add aria-label only if not already present
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", `Page number input ${index + 1}`);
      }
    });
  }, []);

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>

              <Typography sx={{color: "text.primary"}}>
                Issued Policies
              </Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.propUnderProgTitle}>
              <h3> Issued Policies </h3>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={issuedPoliciesCount || 0} // Use correct count
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>

            <Paper className={style.propTableMain}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(user?.user_type === "agent"
                        ? agentColumns
                        : columns
                      ).map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      {/* <TableCell> Actions </TableCell> */}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {/* {issuedPolicyList.map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((column) => (
                          <TableCell key={column.id}>
                            {renderCellContent(column.id, row)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))} */}

                    {/* {issuedPolicyList.map((row, rowIndex) => (
                      <TableRow key={row.id}>
                        {(user?.user_type === "agent" ? agentColumns : columns).map((column) => {
                          let value;
                          if (column.id === "id") {
                            value = rowIndex + 1;
                          } else {
                            value = row[column.id];
                          }
                          return (
                            <TableCell
                              key={column.id}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.renderCell
                                ? column.renderCell({ ...row, value })
                                : value}
                            </TableCell>
                          );
                        })}

                      </TableRow>
                    ))} */}
                    {issuedPolicyList.map((row, rowIndex) => (
                      <TableRow key={row.id}>
                        {(user?.user_type === "agent"
                          ? agentColumns
                          : columns
                        ).map((column) => {
                          let value;
                          if (column.id === "id") {
                            value = rowIndex + 1;
                          } else {
                            value = row[column.id];
                          }
                          return (
                            <TableCell
                              key={column.id}
                              style={{minWidth: column.minWidth}}
                            >
                              {column.renderCell
                                ? column.renderCell(row, value)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {issuedPolicyList?.length > 0
                  ? null
                  : !showLoader && <NoDataComponent />}
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </section>

      {/* 
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}

      >
        <div className={style.claimPopTitle}>
          <h2> Claim Form </h2>
          <p>Policy Number: xxxxxxxxxxx</p>
        </div>

        <DialogContent >

          <Grid container spacing={2} >
            <Grid size={{ xs: 12, md: 12 }} className={style.claimPopMain}>
              <Grid container spacing={2} >
                <Grid size={{ xs: 12, md: 6 }} >
                  <Box sx={{ mb: 1, color: '#000' }}>Date Reported*</Box>
                  <GlobalDateField />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} >
                  <Box sx={{ mb: 1, color: '#000' }}>Date of Loss*</Box>
                  <GlobalDateField />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} >
                  <Box sx={{ mb: 1, color: '#000' }}>Estimated Loss Amount*</Box>
                  <GlobalTextField placeH="$" />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }} >
                  <Box sx={{ mb: 1, color: '#000' }}>Type of Loss*</Box>
                  <GlobalSelectField />
                </Grid>
                <Grid size={{ xs: 12, md: 12 }} >
                  <Box sx={{ mb: 1, color: '#000' }}>Specify Reason if Other</Box>
                  <GlobalTextField />
                </Grid>

                <Button className={style.claimPopBtn} variant='contained' autoFocus onClick={handleClose}>
                  Request Claim
                </Button>
              </Grid>
            </Grid>
          </Grid>

        </DialogContent>

      </BootstrapDialog> */}

      <ClaimFormModal />
    </>
  );
};

export default IssuedPolicy;
